import { useCustomDimensionPanelStore } from '@components/../emp-3.0/components/custom-dimension/custom-dimension-panel/store';
import { useBlockEventSinglePanelStore } from '@components/block-event-single/store';
import { useDataTransformPanelStore } from '@components/data-transform-panel/store';
import { useMappingPanelStore } from '@components/mapping-panel/store';
import { useScrollTo } from '@hooks/index';

const useTopPanelStore = () => {
  const { scrollToTop } = useScrollTo();

  const { mappingPanelOpen, setMappingPanelOpen, resetMappingStore } = useMappingPanelStore(
    (state) => state,
  );
  const { blockEventSingleOpen, setBlockEventSingleOpen, resetBlockEventSingleStore } =
    useBlockEventSinglePanelStore((state) => state);
  const { transformPanelOpen, setTransformPanelOpen, resetTransformStore } =
    useDataTransformPanelStore((state) => state);
  const { customDimensionPanelOpen, setCustomDimensionPanelOpen, resetCustomDimensionStore } =
    useCustomDimensionPanelStore((state) => state);

  const resetMappingPanelStore = () => {
    if (mappingPanelOpen) {
      resetMappingStore();
    }
  };
  const resetBlockEventSinglePanelStore = () => {
    if (blockEventSingleOpen) {
      resetBlockEventSingleStore();
    }
  };
  const resetTransformPanelStore = () => {
    if (transformPanelOpen) {
      resetTransformStore();
    }
  };
  const resetCustomDimensionPanelStore = () => {
    if (customDimensionPanelOpen) {
      setCustomDimensionPanelOpen(false);
      resetCustomDimensionStore();
    }
  };
  const openMappingPanel = () => {
    setMappingPanelOpen(true);
    scrollToTop();
    resetBlockEventSinglePanelStore();
    resetTransformPanelStore();
    resetCustomDimensionPanelStore();
  };
  const openBlockEventSinglePanel = () => {
    setBlockEventSingleOpen(true);
    scrollToTop();
    resetMappingPanelStore();
    resetTransformPanelStore();
    resetCustomDimensionPanelStore();
  };
  const openTransformPanel = () => {
    setTransformPanelOpen(true);
    scrollToTop();
    resetMappingPanelStore();
    resetBlockEventSinglePanelStore();
    resetCustomDimensionPanelStore();
  };
  const openCustomDimensionPanel = () => {
    setCustomDimensionPanelOpen(true);
    scrollToTop();
    resetMappingPanelStore();
    resetBlockEventSinglePanelStore();
    resetTransformPanelStore();
  };

  return {
    openMappingPanel,
    openBlockEventSinglePanel,
    openTransformPanel,
    openCustomDimensionPanel,
    resetMappingPanelStore,
    resetBlockEventSinglePanelStore,
    resetTransformPanelStore,
    resetCustomDimensionPanelStore,
  };
};

export default useTopPanelStore;
